import { useLocation } from "react-router-dom"

export function useIsOnboardingRoute() {
  const location = useLocation()
  return location.pathname.includes("/onboarding")
}
